<div [class]="classForOverlay(!ps.isActive)" overlay>
  <div #overlay panel>
    @if (ps.info != null) {
      <div label>{{ ps.info }}</div>
    }
    <div progress>
      <mat-progress-bar [value]="value" mode="determinate"></mat-progress-bar>
      @if (ps.showCurrent) {
        <div current>{{ currentText }}</div>
      }
    </div>
    <div label>{{ ps.text }}</div>
    @if (ps.mayCancel) {
      <button (click)="ps.cancel()" mat-icon-button>
        <mat-icon>cancel</mat-icon>
      </button>
    }
  </div>
</div>
